/**
 * common style settings
 */
export const ddStyles = {
	control: styles => ({
		...styles, backgroundColor: 'white', borderRadius: '10px',
		lineHeight: '25px', minHeight: '30px', height: '35px', fontSize: '16px', verticalAlign: 'middle'
	}),
	option: (styles, state) => {
		return {
			...styles,
			lineHeight: '25px', height: '35px', fontSize: '16px',
			fontWeight: state.isSelected ? "bold" : "normal", textAlign: 'left',
			color: state.data && state.data.color ? state.data.color : ''
		};
	},
	singleValue: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '35px', fontSize: '16px', marginTop: '4px', textAlign: 'left',
		color: state.data && state.data.color ? state.data.color : ''
	}),
	indicatorSeparator: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '16px', marginTop: '0px',
	}),
	indicatorContainer: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '16px', marginTop: '4px',
	}),
	indicatorsContainer: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '16px', marginTop: '4px',
	}),
	container: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '35px', fontSize: '16px', maxWidth: '30vw', whiteSpace: 'nowrap',
	}),
	input: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '16px',
	}),
	placeholder: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '16px', marginTop: '0px',
	}),
}
export const ddStylesSmall = {
	control: styles => ({
		...styles, backgroundColor: 'white', borderRadius: '10px',
		lineHeight: '25px', minHeight: '30px', height: '35px', fontSize: '12px', verticalAlign: 'middle'
	}),
	option: (styles, state) => {
		return {
			...styles,
			lineHeight: '25px', height: '35px', fontSize: '12px',
			fontWeight: state.isSelected ? "bold" : "normal", textAlign: 'left',
			color: state.data && state.data.color ? state.data.color : ''
		};
	},
	singleValue: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '35px', fontSize: '12px', marginTop: '4px', textAlign: 'left'
	}),
	indicatorSeparator: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '12px', marginTop: '0px',
	}),
	indicatorContainer: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '12px', marginTop: '4px',
	}),
	indicatorsContainer: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '12px', marginTop: '4px',
	}),
	container: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '35px', fontSize: '12px', maxWidth: '30vw', whiteSpace: 'nowrap',
	}),
	input: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '12px',
	}),
	placeholder: (styles, state) => ({
		...styles,
		lineHeight: '25px', height: '30px', fontSize: '12px', marginTop: '0px',
	}),
}